import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ResortsActions } from '../../../../../redux/resorts';
import './places.styles.css';
import Grid from '@material-ui/core/Grid';
import layout from '../../../../../common/layout';

class Places extends Component {
    constructor() {
        super();
        this.state = {
            places: undefined
        }
    }
    componentWillReceiveProps = async (next) => {
       await this.setState({ places: next.places });
    }

    renderPlaces = (places) => {
        const { setCurrentPlaceMap, currentPlace } = this.props;
        return places.map((item, key) => (
                 <Grid item lg xs={12} key={key} className="item" >
                    <h3 style={{color:currentPlace&&item.name==currentPlace.name?layout.gold:'white'}} 
                    onClick={() => setCurrentPlaceMap(item)}
                    >{item.name}</h3>
                </Grid>
            )
        );
    }
    render() {
        const { places } = this.state;
        const {currentPlace, currentResort} = this.props;
        return (
            <Grid
                container
                direction="row"
                wrap="wrap"
                className="containerPlaces"
                style={{ backgroundImage: currentPlace&&`url(${currentPlace.img})` }}
            >
                 <span 
                 style={{
                     position:'absolute',
                     backgroundColor:'rgba(0,0,0,.5)',
                     width:'100%',
                     height:300,
                     }}/>
                    {places&&this.renderPlaces(places)}
                
                 
            </Grid>
        );
    }
}


const mapStateToProps = state => ({
    places: state.ResortsReducer.places,
    currentPlace: state.ResortsReducer.currentPlace,
    currentResort : state.ResortsReducer.currentResort,
});

const mapDispatchToProps = dispatch => ({
    setCurrentPlaceMap: (place) => {
        dispatch(ResortsActions.setCurrentPlace(place));
    },
});

// make this component available to the app
export default connect(mapStateToProps, mapDispatchToProps)(Places);
